import store from '../../../store/index';

export default {
	namespaced: true,
	state: () => ({
		/** -----------提现信息 -----------**/
		data_list: [], // 提现数据
		currentIndex: 0, // 当前提现方式的索引值
		currentLimitIndex: 0, // 当前提现额度的索引值
		withdrawalCategory: '活动提现', // 当前提现类别名
		price_id: null, // 提现额度id
		channel_id: null, // 提现渠道id
		channel_name: null, // 提现渠道中文
		code: null, // 提现渠道英文名
		item: null, // 当前提现额度项信息
		person: {
			// 提现用户信息
			ID: null,
			realname: null,
		},
		priceList: [],
		/** -----------用户信息 -----------**/
		user_info: null,
		/** -----------活动信息 -----------**/
		cash_reward_task_info: null, // 头部任务弹窗信息
		follow_wechat_subscription: null, // 微信公众号是否绑定判别码
		has_show_withdrawal: null, //
		hour_withdraw_data: null, // 0.1福利提现数据
		hour_withdraw_data_status: null, // 0.1福利提现状态码
		hour_withdraw_data_price_id: null, // 0.1福利提现id
		is_today_first_in: null, // 是否首次进入
		sign_in_days: null, // 登录天数
		window_banner_ab: null, // 引流弹窗分组（a代表不显示，b代表只弹首屏，c代表只弹附着弹窗）
		withdraw_success_show: null, // 提现成功展示信息
		withdrawal_rule_desc_window: null, // 提现规则弹窗展示
		/** -----------状态信息 -----------**/
		isShareDialog: false, // 是否处于分享状态
		limitHourWithdraw: false, // 是否处于0.1福利提现状态下
		jd_finance_active_window: false, // 是否展示京东金融首屏弹窗
		jd_finance_rule_window: false, // 是否展示京东金融附着弹窗
		jd_finance_window_text: null, // 选择京东金融哪一套文案，1--第一套，2--第二套
		/** -----------路径信息 -----------**/
		pathName: null,
		weixinExceptionAB: 'b',
		withdrawal_window_button_ab: '', // 提现引流弹窗按钮ab
		vipWithdrawShowAb: 'c',
		button_task: {},
		floatingLayerVipAb: '',
		personalInformationVipAb: '',
		tourist_withdrawl_enable: false,
		rush_info: {
			goods_sort: 0,
			rush_id: 0,
			status: 0,
			ticket_left: 0,
			time_left: 0,
		},
		rush_timer: null,
		rush_coundown_text: '',
		blind_info: {
			ad_group_id: 0,
			code: '',
			countdown: 0,
			currNum: '',
			nextRoundStartTime: '',
			roiLevel: '',
			startTime: '',
			status: '',
		},
		blind_timer: null,
		blind_coundown_text: '',
		blind_btn_valid: true,
	}),
	mutations: {
		// 提现方式改变执行，刷新默认选项的数据
		changeWithdrawWay(state, obj) {
			const { index, channel_code, channel_id, channel_name } = obj;
			state.currentIndex = index;
			state.channel_id = channel_id;
			state.channel_name = channel_name;
			state.code = channel_code;
			state.currentLimitIndex = 0;

			const tagList = state.data_list[state.currentIndex].tag_list;

			if (tagList) {
				state.withdrawalCategory = tagList && tagList[0].tag_name;
				// 再次进行数据初始化
				let payload = { list: state.data_list, origin: '' };
				store.commit('withdraw/jdFinance/initWithdrawInfo', payload);
			}
		},
		// 提现数据初始化
		initWithdrawInfo(state, payload) {
			function shuffle(arr) {
				let i = arr.length;
				while (i) {
					let j = Math.floor(Math.random() * i--);
					[arr[j], arr[i]] = [arr[i], arr[j]];
				}
				return arr;
			}
			const rList = [...payload.list];
			let firstItem = {};
			if (
				rList.length &&
				rList[0].tag_list &&
				rList[0].tag_list.length &&
				rList[0].tag_list[0].price_list &&
				rList[0].tag_list[0].price_list.length
			) {
				let idx = rList[0].tag_list[0].price_list.findIndex((i) => i.type === "new");
				if (idx !== -1) {
					firstItem = rList[0].tag_list[0].price_list.splice(idx, 1)[0];
					rList[0].tag_list[0].price_list = shuffle(rList[0].tag_list[0].price_list);
					rList[0].tag_list[0].price_list.unshift(firstItem);
				} else {
					rList[0].tag_list[0].price_list = shuffle(rList[0].tag_list[0].price_list);
				}
			}

			state.data_list = [...rList];

			// console.log(`state`, state);
			// console.log(`payload`, payload);
			// 页面 onShow 时，只更新页面数据，不改变展示逻辑
			if (payload.origin === 'show') {
				console.log(`state.item`, state.item);
				console.log(`state.currentLimitIndex`, state.currentLimitIndex);
				if (state.item.type === 'new') {
					let tagIndex = payload.list[state.currentIndex].tag_list.findIndex((v) => v.tag_id === 6);
					if (tagIndex !== -1) {
						// 还有新人提现通道方式
						let priceList = payload.list[state.currentIndex].tag_list[tagIndex].price_list;
						state.priceList = priceList;
						if (priceList[state.currentLimitIndex].show_data.is_ash) {
							// 如果当前的选择已经置灰
							let index = priceList.findIndex((item) => !item.show_data.is_ash); // 找到第一个未置灰的通道索引
							state.item = priceList[index];
							state.currentLimitIndex = index;
							state.withdrawalCategory = payload.list[state.currentIndex].tag_list[tagIndex].tag_name;
						}
					} else {
						// 新人提现通道已经提完，移到下一个通道第一个
						state.currentLimitIndex = 0;
						state.item = payload.list[state.currentIndex].tag_list[0].price_list[0];
						const rushInfo = state.item.rush_info;
						if (rushInfo && Object.keys(rushInfo).length) {
							store.commit('withdraw/jdFinance/setRushInfo', rushInfo);
						}
						state.withdrawalCategory = payload.list[state.currentIndex].tag_list[0].tag_name;
					}
				} else {
					console.log(`else`, state.item);
				}
				// console.log(`state.item`, state.item);
				// console.log(`state.data_list`, state.data_list);
				let priceList = payload.list[state.currentIndex].tag_list[0].price_list;

				state.item = priceList[state.currentLimitIndex];

				store.commit('withdraw/jdFinance/updateBlindInfo', payload);
				return;
			}

			if (payload.list[state.currentIndex]) {
				const { channel_id, channel_code, channel_name } = payload.list[state.currentIndex];
				state.channel_id = channel_id;
				state.channel_name = channel_name;
				state.code = channel_code;
				console.log(`state.currentIndex => ${state.currentIndex}`);
				console.log(`payload.list[state.currentIndex]`, payload.list[state.currentIndex]);
				if (
					payload.list[state.currentIndex].tag_list &&
					payload.list[state.currentIndex].tag_list.length >= 1 &&
					payload.list[state.currentIndex].tag_list[0].price_list &&
					payload.list[state.currentIndex].tag_list[0].price_list.length >= 1
				) {
					let priceList = payload.list[state.currentIndex].tag_list[0].price_list;
					state.priceList = priceList;

					let index = priceList.findIndex((item) => !item.show_data.is_ash); // 第一个未置灰的通道
					state.item = priceList[index];

					const rushInfo = state.item.rush_info;
					if (rushInfo && Object.keys(rushInfo).length) {
						store.commit('withdraw/jdFinance/setRushInfo', rushInfo);
					}

					store.commit('withdraw/jdFinance/updateBlindInfo', payload);
					state.currentLimitIndex = index;
					state.withdrawalCategory = payload.list[state.currentIndex].tag_list[0].tag_name;
				}
			}
		},
		// 活动数据初始化
		initActivityInfo(state, obj) {
			const {
				cash_reward_task_info,
				follow_wechat_subscription,
				has_show_withdrawal,
				is_today_first_in,
				sign_in_days,
				window_banner_ab,
				withdraw_success_show,
				withdrawal_rule_desc_window,
				user_info,
				hour_withdraw_data,
				jd_finance_window_text,
				withdrawal_window_button_ab,
				vip_withdraw_channel_show_ab,
				floating_layer_vip_ab,
				personal_information_vip_ab,
			} = obj;
			(state.cash_reward_task_info = cash_reward_task_info),
				(state.follow_wechat_subscription = follow_wechat_subscription),
				(state.has_show_withdrawal = has_show_withdrawal),
				(state.is_today_first_in = is_today_first_in),
				(state.sign_in_days = sign_in_days),
				(state.window_banner_ab = window_banner_ab);
			(state.withdraw_success_show = withdraw_success_show), (state.withdrawal_rule_desc_window = withdrawal_rule_desc_window);

			state.hour_withdraw_data = hour_withdraw_data;
			if (hour_withdraw_data.desc_params && hour_withdraw_data.desc_params.status) {
				state.hour_withdraw_data_status = hour_withdraw_data.desc_params.status;
			}

			state.hour_withdraw_data_status == 1 && (state.limitHourWithdraw = true);
			state.hour_withdraw_data_price_id = hour_withdraw_data.price_id;
			// //原京东金融迭代逻辑
			// state.jd_finance_active_window = jd_finance_active_window
			// state.jd_finance_rule_window = jd_finance_rule_window
			// 暂时关闭京东金融迭代弹窗
			state.jd_finance_active_window = false;
			state.jd_finance_rule_window = false;

			state.jd_finance_window_text = jd_finance_window_text;
			state.withdrawal_window_button_ab = withdrawal_window_button_ab;
			state.vipWithdrawShowAb = vip_withdraw_channel_show_ab;
			state.floatingLayerVipAb = floating_layer_vip_ab;
			state.personalInformationVipAb = personal_information_vip_ab;
		},
		setUserInfo(state, payload) {
			state.user_info = payload;
			localStorage.setItem('user_info', JSON.stringify(payload));
		},
		// 提现额度切换，刷新默认选项的数据
		changeWithdrawLimit(state, obj) {
			const { index, category, item } = obj;
			state.currentLimitIndex = index;
			state.withdrawalCategory = category;
			state.item = item;
			const rushInfo = state.item.rush_info;
			if (rushInfo && Object.keys(rushInfo).length) {
				store.commit('withdraw/jdFinance/setRushInfo', rushInfo);
			}
			if (state.item.show_data.blind_box) {
				store.commit('withdraw/jdFinance/setBlindInfo', state.item.show_data.blind_box);
			}
		},
		// 重置用户身份
		resetPersonInfo(state) {
			state.person = {
				ID: null,
				realname: null,
			};
		},
		// 更新用户身份
		updatePersonInfo(state, data) {
			state.person = data;
		},
		// 更改分享状态
		changeShareStatus(state, status) {
			state.isShareDialog = status;
		},
		// 更改提现状态（true代表处于0.1提现状态下，false处于普通提现）
		changeWithdrawStatus(state, status) {
			state.limitHourWithdraw = status;
		},
		// ios微信公众号获取用户信息
		setWxUserInfo(state, info) {
			state.user_info = info;
			localStorage.setItem('user_info', JSON.stringify(info));
		},
		// 存储当前的pathname，用于区分微信公众号实名认证 or 提现页面实名认证
		setCurrentPathName(state, data) {
			state.pathName = data;
		},
		setWeixinExceptionAb(state, data) {
			localStorage.setItem('weixinExceptionAB', data);
			state.weixinExceptionAB = data;
		},
		setTouristWithdrawlEnable(state, data) {
			state.tourist_withdrawl_enable = data;
		},
		// 规则弹窗button信息
		setButtonTask(state, data) {
			// if (data.task.link.indexOf('ky-h5') === -1 && data.task.link.indexOf('http') === -1) {
			// 	const appName = this.getters.client['app-name'] || 'kuaiyin';
			//
			// 	data.task.link = `${appName}${data.task.link}`;
			// }
			state.button_task = data;
		},
		setRushInfo(state, data) {
			// 格式化
			let twoByte = (num) => {
				num = String(num);
				if (num.length < 2) {
					return '0' + num;
				}
				return num;
			};
			let startCountdown = (seconds) => {
				clearInterval(state.rush_timer);
				let countdown = { h: '00', m: '00', s: '00' };
				let countDown = () => {
					seconds--;
					if (seconds <= 0) {
						clearInterval(state.rush_timer);
						state.rush_timer = null;
						countdown = { h: '00', m: '00', s: '00' };
						state.rush_coundown_text = '00:00:00';
						return;
					}
					countdown.h = twoByte(Math.floor(seconds / 3600) % 24);
					countdown.m = twoByte(Math.floor((seconds % 3600) / 60));
					countdown.s = twoByte(seconds % 60);
					state.rush_coundown_text = `${countdown.h}:${countdown.m}:${countdown.s} `;
				};
				state.rush_timer = setInterval(countDown, 1000);
				countDown();
			};

			if (data) {
				state.rush_info = data;
				const { time_left, end_left, status } = data;
				if (!state.rush_timer) {
					if (+status === 0) {
						if (time_left) {
							let seconds = time_left;
							startCountdown(seconds);
						}
					} else if (+status === 1) {
						if (end_left) {
							let seconds = end_left;
							startCountdown(seconds);
						}
					}
				}
			}
		},
		setBlindInfo(state, data) {
			console.log(`setBlindInfo data`, data);
			// 格式化
			let twoByte = (num) => {
				num = String(num);
				if (num.length < 2) {
					return '0' + num;
				}
				return num;
			};
			let startCountdown = (seconds) => {
				clearInterval(state.blind_timer);
				let countdown = { h: '00', m: '00', s: '00' };
				let countDown = () => {
					seconds--;
					if (seconds <= 0) {
						clearInterval(state.blind_timer);
						state.blind_timer = null;
						countdown = { h: '00', m: '00', s: '00' };
						state.blind_coundown_text = '00:00:00 后再次领取';
						return;
					}
					countdown.h = twoByte(Math.floor(seconds / 3600) % 24);
					countdown.m = twoByte(Math.floor((seconds % 3600) / 60));
					countdown.s = twoByte(seconds % 60);
					state.blind_coundown_text = `${countdown.h}:${countdown.m}:${countdown.s} 后再次领取`;
				};
				state.blind_timer = setInterval(countDown, 1000);
				countDown();
			};

			if (data) {
				state.blind_info = data;
				const { countdown, status } = data;
				if (!state.blind_timer) {
					if (+status === 2) {
						if (countdown) {
							let seconds = countdown;
							startCountdown(seconds);
						}
					}
				}
			}
		},
		setBlindBtnValid(state, data) {
			state.blind_btn_valid = data;
		},
		updateBlindInfo(state, payload) {
			console.log(`updateBlindInfo payload`, payload);
			let priceList = payload.list[state.currentIndex].tag_list[0].price_list;

			// 找到是否存在 blind_box 选项
			let [blindBoxItem] = priceList.filter((item) => {
				return item.show_data && item.show_data.blind_box;
			});

			console.log(`updateBlindInfo blindBoxItem`, blindBoxItem);

			if (blindBoxItem && blindBoxItem.show_data && blindBoxItem.show_data.blind_box) {
				const {
					show_data: { blind_box },
				} = blindBoxItem;

				store.commit('withdraw/jdFinance/setBlindInfo', blind_box);
			}
		},
	},
	actions: {},
	getters: {
		data_list: (state) => {
			return state.data_list;
		},
		currentIndex: (state) => {
			return state.currentIndex;
		},
		currentLimitIndex: (state) => {
			return state.currentLimitIndex;
		},
		withdrawalCategory: (state) => {
			return state.withdrawalCategory;
		},
		price_id: (state) => {
			return state.price_id;
		},
		channel_id: (state) => {
			return state.channel_id;
		},
		channel_name: (state) => {
			return state.channel_name;
		},
		code: (state) => {
			return state.code;
		},

		item: (state) => {
			return state.item;
		},
		person: (state) => {
			return state.person;
		},

		user_info: (state) => {
			if (state.user_info) {
				return state.user_info;
			} else {
				if (localStorage.getItem('user_info')) {
					return JSON.parse(localStorage.getItem('user_info'));
				}
			}
		},
		cash_reward_task_info: (state) => {
			return state.cash_reward_task_info;
		},
		follow_wechat_subscription: (state) => {
			return state.follow_wechat_subscription;
		},
		has_show_withdrawal: (state) => {
			return state.has_show_withdrawal;
		},

		hour_withdraw_data: (state) => {
			return state.hour_withdraw_data;
		},
		hour_withdraw_data_status: (state) => {
			return state.hour_withdraw_data_status;
		},
		hour_withdraw_data_price_id: (state) => {
			return state.hour_withdraw_data_price_id;
		},
		is_today_first_in: (state) => {
			return state.is_today_first_in;
		},
		sign_in_days: (state) => {
			return state.sign_in_days;
		},
		window_banner_ab: (state) => {
			return state.window_banner_ab;
		},
		withdraw_success_show: (state) => {
			return state.withdraw_success_show;
		},
		withdrawal_rule_desc_window: (state) => {
			return state.withdrawal_rule_desc_window;
		},
		isShareDialog: (state) => {
			return state.isShareDialog;
		},
		limitHourWithdraw: (state) => {
			return state.limitHourWithdraw;
		},
		jd_finance_active_window: (state) => {
			return state.jd_finance_active_window;
		},
		jd_finance_rule_window: (state) => {
			return state.jd_finance_rule_window;
		},
		jd_finance_window_text: (state) => {
			return state.jd_finance_window_text;
		},
		pathName: (state) => {
			return state.pathName;
		},
		weixinExceptionAb: (state) => {
			if (localStorage.getItem('weixinExceptionAB')) {
				return localStorage.getItem('weixinExceptionAB');
			} else {
				return state.weixinExceptionAB;
			}
		},
		withdrawalWindowButtonAb: (state) => {
			return state.withdrawal_window_button_ab;
		},
		vipWithdrawShowAb: (state) => {
			return state.vipWithdrawShowAb;
		},
		buttonTask: (state) => {
			return state.button_task;
		},
		floatingLayerVipAb: (state) => {
			return state.floatingLayerVipAb;
		},
		personalInformationVipAb: (state) => {
			return state.personalInformationVipAb;
		},
		touristWithdrawlEnable: (state) => {
			return state.tourist_withdrawl_enable;
		},
		rushInfo: (state) => {
			return state.rush_info;
		},
		rushTimer: (state) => {
			return state.rush_timer;
		},
		rushCountDownText: (state) => {
			return state.rush_coundown_text;
		},
		blindInfo: (state) => {
			return state.blind_info;
		},
		blindTimer: (state) => {
			return state.blind_timer;
		},
		blindCountDownText: (state) => {
			return state.blind_coundown_text;
		},
		blindBtnValid: (state) => {
			return state.blind_btn_valid;
		},
		PriceList: (state) => {
			return state.priceList;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/Withdraw/modules/jd-finance.js